<template>
  <v-select
    clearable
    class="m-0 p-0"
    :items="accounts"
    item-text="fname"
    :label="label"
    outlined
    return-object
    v-model="selectedAccount"
    @input="onAccountSelected()"
  ></v-select>
</template>

<script>
export default {
  props: {
    accountSelection: {
      type: Object,
      default: undefined
    },
    label: {
      type: String,
      default : "Accounts"
    }
  },
  async created() {
    await this.$store.dispatch("getAccounts");
    this.selectedAccount = this.accountSelection;
  },
  data: () => ({
    selectedAccount : undefined,
  }),
  computed: {
    accounts() {
      return this.$store.state.accounts;
    },
  },
  methods: {
    onAccountSelected() {
      this.$emit("onAccountSelected", this.selectedAccount);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>